/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const addItemsToAlbumCollectionModelSchema = z.object({
    "albumIds": z.array(z.string().uuid()).describe("Идентификаторы альбомов")
    })